import { IChatUserDto, IMessageDto, IMessageOfferParsedText, OfferStatusEnum } from '@/Models/Chat'
import { colors } from '@/styles/colors';
import { Chip } from '@mui/material';
import React from 'react'
import { useTranslation } from 'next-i18next';
import { StyledOfferMessage } from '../ChatMessages.style';
import { DateService } from '@/Services/DateService';

type Props = {
  data: IMessageDto;
  isSender: boolean;
  chatData: IChatUserDto;
}

const OfferMessage = ({ data, isSender, chatData }: Props) => {
  const { t } = useTranslation();
  const OfferData = JSON.parse(data.text) as IMessageOfferParsedText;

  let text = '';
  switch (OfferData.status) {
    case OfferStatusEnum.ACCEPTED: {
      text = isSender
      ? t('you_accepted_offer', { key: OfferData.price, key2: t(OfferData.currencyType) })
      : t('seller_accepted_your_offer', { key: chatData.name, key2: OfferData.price, key3: t(OfferData.currencyType) });
      break;
    }
    case OfferStatusEnum.REJECTED: {
      text = isSender
      ? t('you_rejected_this_offer', { key: OfferData.price, key2: t(OfferData.currencyType) })
      : t('seller_rejected_your_offer', { key: chatData.name, key2: OfferData.price, key3: t(OfferData.currencyType) });
      break;
    }
    case OfferStatusEnum.CANCELED: {
      text = isSender
      ? t('you_canceled_deal', { key: OfferData.price, key2: t(OfferData.currencyType) })
      : t('chatter_canceled_deal', { key: chatData.name, key2: OfferData.price, key3: t(OfferData.currencyType) });
      break;
    }
    case OfferStatusEnum.PENDING: {
      text = isSender
      ? t('you_offered', { key: OfferData.price, key2: t(OfferData.currencyType) })
      : t('buyer_offered', { key: chatData.name, key2: OfferData.price, key3: t(OfferData.currencyType) });
      break;
    }
    case OfferStatusEnum.SOLD: {
      text = t('product_sold_for_this', { key: OfferData.price, key2: t(OfferData.currencyType) });
      break;
    }
    default: {
      return null;
    }
  }
  

  return (
    <StyledOfferMessage className='chat-messages__item chat-messages__location'>
      {/* <Chip label={text} sx={{
        padding: '5px',
        borderRadius: '10px',
        fontSize: '12px',
        lineHeight: 'normal',
        backgroundColor: 'transparent',
        color: colors.primary,
        border: `1px solid ${colors.secondary}`,
        fontFamily: '"Inter" sans-serif'
      }} size='medium' /> */}
      <div style={{
        padding: '5px',
        borderRadius: '10px',
        fontSize: '12px',
        lineHeight: 'normal',
        backgroundColor: 'transparent',
        color: colors.primary,
        border: `1px solid ${colors.secondary}`,
        fontFamily: '"Inter" sans-serif',
        textAlign: 'center'
      }}>
        { text }
      </div>
      <span style={{ width: '100%', textAlign: 'right', paddingRight: '5px' }} className='chat-messages__time-text'>{ DateService.toHHMM(data.createdAt) }</span>
    </StyledOfferMessage>
  )
}

export default OfferMessage;
